import _slicedToArray from "/home/ubuntu/onesaz/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import Color from '../Color.js';
Color.prototype.get = function (mc) {
  var _mc$split = mc.split('.'),
    _mc$split2 = _slicedToArray(_mc$split, 2),
    mode = _mc$split2[0],
    channel = _mc$split2[1];
  var src = this[mode]();
  if (channel) {
    var i = mode.indexOf(channel) - (mode.substr(0, 2) === 'ok' ? 2 : 0);
    if (i > -1) return src[i];
    throw new Error("unknown channel ".concat(channel, " in mode ").concat(mode));
  } else {
    return src;
  }
};